import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react"

import DataElement from "../DataElement"
import DateFromToMonthYearInput from "../DateFromToMonthYearInput"
import OptionInput from "../OptionInput"
import TextInput from "../TextInput"

const options = [
    {
        title: "Select",
        key: "",
    },
    {
        title: "Yes",
        key: "yes",
    },
    {
        title: "No",
        key: "no",
    },
]

const IsUnemploymentAndDataInput = forwardRef(({ title, attributes, data, readOnly }, ref) => {

    const fieldData = data || {
        wasUnemployment: options[0].key,
        reasonForUnemployment: "",
    }

    const [optionWasUnemployed, setOptionWasUnemployed] = useState(fieldData.wasUnemployed)

    const optionRef = useRef()
    const employmentDataRef = useRef()
    const reasonInputRef = useRef()
    const unemployedDateRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const optionResult = optionRef.current.validateAndGetData()
            const employmentDataResult = employmentDataRef.current?.validateAndGetData()
            const reasonInputData = reasonInputRef.current?.validateAndGetData();
            const unemployedDataResult = unemployedDateRef?.current?.validateAndGetData()
            return {
                isValid: optionResult.isValid &&
                    (employmentDataResult?.isValid ?? true) &&
                    (optionWasUnemployed === "yes" ? (reasonInputData?.isValid && unemployedDataResult?.isValid) : true),

                value: {
                    wasUnemployed: optionResult.value,
                    employmentData: employmentDataResult?.value,
                    reasonForUnemployment: optionWasUnemployed === "yes" ? reasonInputData?.value : null,
                    dateFromTo: optionWasUnemployed === "yes" ? unemployedDataResult?.value : null,

                },
            }
        },
    }))

    return (
        <div className="my-4">

            <OptionInput
                ref={optionRef}
                data={fieldData.wasUnemployed}
                options={options}
                title={"Was Unemployed for a Period?"}
                valueChangeHandler={setOptionWasUnemployed}
                readOnly={readOnly}
            />
            {optionWasUnemployed === "yes" && (
                <div className="mt-4">
                    <TextInput
                        ref={reasonInputRef}
                        title={"Reason"}
                        data={fieldData.reasonForUnemployment}
                        isMandatory={true}
                        validator={(val) => val.trim().length > 0}
                        disabled={readOnly}
                    />
                    <DateFromToMonthYearInput
                        title={""}
                        ref={unemployedDateRef}
                        data={fieldData.dateFromTo}
                        readOnly={readOnly}
                        maxFutureYearsFromNow={0}
                    />
                </div>
            )}
            {optionWasUnemployed === "no" && (
                <DataElement
                    title={"Date when Qualification/Degree was received?"}
                    ref={employmentDataRef}
                    data={fieldData.employmentData}
                    attributes={attributes.filter(attribute => attribute.key !== "was_unemployed")}
                    readOnly={readOnly}
                />
            )
            }
        </div>
    )
})

export default IsUnemploymentAndDataInput
